import React, { useState, useEffect } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  TextField,
  Paper,
  Typography,
  Snackbar,
  Alert,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Card,
  CardContent,
  TablePagination,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';

const drawerWidth = 240;

function Exam() {
  const [examType, setExamType] = useState([]);
  const [subExam, setSubExam] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [students, setStudents] = useState([]);
  const [showStudentList, setShowStudentList] = useState(false);
  const [editingStudents, setEditingStudents] = useState([]);
  const [newMarks, setNewMarks] = useState({});
  const [selectedExamType, setSelectedExamType] = useState('');
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [selectedSubExam, setSelectedSubExam] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const fetchExamType = async () => {
    try {
      const response = await fetch('https://wsmsv1.aidigitalsec.com/api/Teacher/ddlExam_Examination', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
      });
      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        setExamType(data);
        return true;
      } else if (data && Array.isArray(data.examType) && data.examType.length > 0) {
        setExamType(data.examType);
        return true;
      } else {
        setExamType([]);
        return false;
      }
    } catch (error) {
      console.error('Error fetching exam types:', error);
      setExamType([]);
      return false;
    }
  };

  const fetchSubExamTypes = async (examCategoryId) => {
    try {
      const response = await fetch('https://wsmsv1.aidigitalsec.com/api/Teacher/ddlExamSubCategory_Examination', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({ examCategoryId }),
      });
      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        setSubExam(data);
        return true;
      } else if (data && Array.isArray(data.subExam) && data.subExam.length > 0) {
        setSubExam(data.subExam);
        return true;
      } else {
        setSubExam([]);
        return false;
      }
    } catch (error) {
      console.error('Error fetching sub-exam types:', error);
      setSubExam([]);
      return false;
    }
  };

  const fetchTeachers = async () => {
    try {
      const response = await fetch('https://wsmsv1.aidigitalsec.com/api/Exam/ddlTeacher', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
      });
      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        setTeachers(data);
        return true;
      } else if (data && Array.isArray(data.teachers) && data.teachers.length > 0) {
        setTeachers(data.teachers);
        return true;
      } else {
        setTeachers([]);
        return false;
      }
    } catch (error) {
      console.error('Error fetching teachers:', error);
      setTeachers([]);
      return false;
    }
  };

  const fetchClasses = async (teacherId) => {
    try {
      const response = await fetch('https://wsmsv1.aidigitalsec.com/api/Teacher/GetClass', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({ teacherId }),
      });
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setClasses([]);
        return false;
      }
      if (Array.isArray(data) && data.length > 0) {
        setClasses(data);
        return true;
      } else {
        setClasses([]);
        return false;
      }
    } catch (error) {
      console.error('Error fetching classes:', error);
      setClasses([]);
      return false;
    }
  };

  const fetchSections = async (teacherId, classId) => {
    try {
      const response = await fetch('https://wsmsv1.aidigitalsec.com/api/Teacher/ddlSection_clsId', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({ teacherId, classId }),
      });
      const data = await response.json();
      if (Array.isArray(data) && data.length > 0) {
        setSections(data);
        return true;
      } else {
        setSections([]);
        return false;
      }
    } catch (error) {
      console.error('Error fetching sections:', error);
      setSections([]);
      return false;
    }
  };

  const fetchSubjects = async (teacherId, classId, sectionId) => {
    try {
      const response = await fetch('https://wsmsv1.aidigitalsec.com/api/Teacher/ddlSubject', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({ teacherId, classId, sectionId }),
      });
      const data = await response.json();
      if (Array.isArray(data) && data.length > 0) {
        setSubjects(data);
        return true;
      } else {
        setSubjects([]);
        return false;
      }
    } catch (error) {
      console.error('Error fetching subjects:', error);
      setSubjects([]);
      return false;
    }
  };

  const fetchStudents = async (details) => {
    try {
      const response = await fetch('https://wsmsv1.aidigitalsec.com/api/Teacher/GetStudentList_Examination', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify(details),
      });
      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        setStudents(data);
        return true;
      } else if (data && Array.isArray(data.students) && data.students.length > 0) {
        setStudents(data.students);
        return true;
      } else {
        setStudents([]);
        return false;
      }
    } catch (error) {
      console.error('Error fetching students:', error);
      setStudents([]);
      return false;
    }
  };

  useEffect(() => {
    const loadInitialData = async () => {
      await fetchExamType();
      await fetchTeachers();
    };
    loadInitialData();
  }, []);

  const validateForm = () => {
    const subExamRequired = Array.isArray(subExam) && subExam.length > 0;
    return selectedExamType && selectedClass && selectedSection && selectedSubject && (subExamRequired ? selectedSubExam : true);
  };

  const handleCheckboxChange = (studentId) => {
    setEditingStudents(prev => {
      if (prev.includes(studentId)) {
        return prev.filter(id => id !== studentId);
      } else {
        return [...prev, studentId];
      }
    });
    setNewMarks(prev => ({
      ...prev,
      [studentId]: students.find(s => s.studentId === studentId)?.obtainedMarks || ''
    }));
  };

  const handleMarksChange = (e, studentId) => {
    setNewMarks(prev => ({
      ...prev,
      [studentId]: e.target.value
    }));
  };

  const handleSave = async () => {
    const payload = editingStudents.map(studentId => {
      const student = students.find(s => s.studentId === studentId);
      return {
        examTypeId: selectedExamType,
        studentId: student.studentId,
        classId: selectedClass,
        sectionId: selectedSection,
        subjectId: selectedSubject,
        maxMarks: student.maxMarks,
        minMarks: student.minMarks,
        obtainedMarks: newMarks[student.studentId] === '' ? 0 : newMarks[student.studentId],
        subExamCategoryId: selectedSubExam,
        isSubject: true,
        isAttendedExam: student.isAttendedExam
      };
    });

    try {
      const response = await fetch('https://wsmsv1.aidigitalsec.com/api/Teacher/SaveStudentMarks_Examination', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        setSnackbarMessage('Marks saved successfully.');
        setSnackbarOpen(true);
        setStudents(prev =>
          prev.map(student =>
            editingStudents.includes(student.studentId)
              ? { ...student, obtainedMarks: newMarks[student.studentId] === '' ? 0 : newMarks[student.studentId] }
              : student
          )
        );
        setEditingStudents([]);
        setNewMarks({});
      } else {
        setSnackbarMessage('Error saving marks.');
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error('Error saving marks:', error);
      setSnackbarMessage('Error saving marks.');
      setSnackbarOpen(true);
    }
  };

  const handleCancel = () => {
    setEditingStudents([]);
    setNewMarks({});
    setSelectedExamType('');
    setSelectedSubExam('');
    setSelectedTeacher('');
    setSelectedClass('');
    setSelectedSection('');
    setSelectedSubject('');
    setShowStudentList(false);
    setStudents([]);
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      const studentDetails = {
        classId: selectedClass,
        sectionId: selectedSection,
        subjectId: selectedSubject,
        examTypeId: selectedExamType,
        ...(Array.isArray(subExam) && subExam.length > 0 ? { subCategoryId: selectedSubExam } : {}),
        isWithSubject: true,
      };

      await fetchStudents(studentDetails);
      setShowStudentList(true);
    } else {
      setSnackbarMessage('Please fill in all required fields.');
      setSnackbarOpen(true);
    }
  };

  const filteredStudents = students.filter(student =>
    student.studentName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    student.rollNo?.toString().includes(searchTerm)
  );

  const paginatedStudents = filteredStudents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box
      component="main"
      sx={{
        width: { md: `calc(100% - ${drawerWidth}px)` },
        ml: { md: `${drawerWidth}px` },
        mt: { xs: 0, sm: '64px' },
        p: { xs: 2, md: 4 },
        backgroundColor: '#f8fafc',
        minHeight: '100vh',
      }}
    >
      <Card sx={{ mb: 4, boxShadow: 4, borderRadius: 3 }}>
        <CardContent>
          <Typography
            variant="h4"
            sx={{
              mb: 4,
              fontWeight: 'bold',
              color: '#063552'
,
              textAlign: 'center',
            }}
          >
            📘 Examination Marks Entry
          </Typography>

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Exam Type *</InputLabel>
                <Select
                  value={selectedExamType}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedExamType(value);
                    setSelectedSubExam('');
                    setSubExam([]);
                    if (value) fetchSubExamTypes(value);
                  }}
                  label="Exam Type *"
                >
                  <MenuItem value="">Select Exam Type</MenuItem>
                  {examType.map((exam) => (
                    <MenuItem key={exam.examTypeId} value={exam.examTypeId}>
                      {exam.examType}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {subExam.length > 0 && (
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Sub Exam *</InputLabel>
                  <Select
                    value={selectedSubExam}
                    onChange={(e) => setSelectedSubExam(e.target.value)}
                    label="Sub Exam *"
                  >
                    <MenuItem value="">Select Sub Exam</MenuItem>
                    {subExam.map((sub) => (
                      <MenuItem key={sub.examSubCategoryId} value={sub.examSubCategoryId}>
                        {sub.examSubCategory}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Teacher</InputLabel>
                <Select
                  value={selectedTeacher}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedTeacher(value);
                    setSelectedClass('');
                    setSelectedSection('');
                    setSelectedSubject('');
                    setClasses([]);
                    setSections([]);
                    setSubjects([]);
                    if (value) fetchClasses(value);
                  }}
                  label="Teacher"
                >
                  <MenuItem value="">Select Teacher</MenuItem>
                  {teachers.map((teacher) => (
                    <MenuItem key={teacher.employeeId} value={teacher.employeeId}>
                      {teacher.employeeName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth variant="outlined" disabled={!selectedTeacher}>
                <InputLabel>Class *</InputLabel>
                <Select
                  value={selectedClass}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedClass(value);
                    setSelectedSection('');
                    setSelectedSubject('');
                    setSections([]);
                    setSubjects([]);
                    if (selectedTeacher && value) fetchSections(selectedTeacher, value);
                  }}
                  label="Class *"
                >
                  <MenuItem value="">Select Class</MenuItem>
                  {classes.map((cls) => (
                    <MenuItem key={cls.classId} value={cls.classId}>
                      {cls.className}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth variant="outlined" disabled={!selectedClass}>
                <InputLabel>Section *</InputLabel>
                <Select
                  value={selectedSection}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedSection(value);
                    setSelectedSubject('');
                    setSubjects([]);
                    if (selectedTeacher && selectedClass && value) {
                      fetchSubjects(selectedTeacher, selectedClass, value);
                    }
                  }}
                  label="Section *"
                >
                  <MenuItem value="">Select Section</MenuItem>
                  {sections.map((sec) => (
                    <MenuItem key={sec.sectionId} value={sec.sectionId}>
                      {sec.sectionName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth variant="outlined" disabled={!selectedSection}>
                <InputLabel>Subject *</InputLabel>
                <Select
                  value={selectedSubject}
                  onChange={(e) => setSelectedSubject(e.target.value)}
                  label="Subject *"
                >
                  <MenuItem value="">Select Subject</MenuItem>
                  {subjects.map((sub) => (
                    <MenuItem key={sub.subjectId} value={sub.subjectId}>
                      {sub.subjectName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 3 }}>
          <Button
  variant="contained"
  size="large"
  onClick={handleSubmit}
  sx={{
    minWidth: 220,
    backgroundColor: '#d97706',   // 🟠 navbar orange
    fontWeight: 600,
    textTransform: 'none',        // first letter capital, rest small
    '&:hover': {
      backgroundColor: '#c2410c', // darker orange on hover
    },
  }}
>
  Get Students
</Button>

            <Button
              variant="outlined"
              color="secondary"
              size="large"
              onClick={handleCancel}
              sx={{ minWidth: 220 }}
            >
              Reset
            </Button>
          </Box>
        </CardContent>
      </Card>

      {showStudentList && (
        <Card sx={{ boxShadow: 4, borderRadius: 3 }}>
          <CardContent>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#1976d2' }}>
              👥 Student Marks ({filteredStudents.length})
            </Typography>

            <Box sx={{ mb: 3 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search by name or roll number..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{ maxWidth: 400 }}
              />
            </Box>

            <TableContainer sx={{ maxHeight: 600, overflowX: 'auto' }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ bgcolor: '#1976d2' }}>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Select</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Student Name</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Roll No</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Class</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Section</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Subject</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Max Marks</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Min Marks</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">Obtained Marks</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedStudents.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={9} align="center" sx={{ py: 6 }}>
                        <Typography variant="h6" color="text.secondary">
                          No students found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    paginatedStudents.map((student) => (
                      <TableRow
                        key={student.studentId}
                        hover
                        selected={editingStudents.includes(student.studentId)}
                      >
                        <TableCell>
                          <Checkbox
                            checked={editingStudents.includes(student.studentId)}
                            onChange={() => handleCheckboxChange(student.studentId)}
                          />
                        </TableCell>
                        <TableCell>{student.studentName}</TableCell>
                        <TableCell align="center">{student.rollNo}</TableCell>
                        <TableCell align="center">{student.className}</TableCell>
                        <TableCell align="center">{student.section}</TableCell>
                        <TableCell align="center">{student.subjectName}</TableCell>
                        <TableCell align="center">{student.maxMarks}</TableCell>
                        <TableCell align="center">{student.minMarks}</TableCell>
                        <TableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            value={
                              editingStudents.includes(student.studentId)
                                ? newMarks[student.studentId] || ''
                                : student.obtainedMarks || ''
                            }
                            disabled={!editingStudents.includes(student.studentId)}
                            onChange={(e) => handleMarksChange(e, student.studentId)}
                            sx={{ width: 100 }}
                            inputProps={{ min: 0, max: student.maxMarks }}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={filteredStudents.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
            />

            {editingStudents.length > 0 && (
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                <Button
                  variant="contained"
                  color="success"
                  size="large"
                  onClick={handleSave}
                  startIcon={<SaveIcon />}
                >
                  Save Marks ({editingStudents.length})
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  size="large"
                  onClick={() => {
                    setEditingStudents([]);
                    setNewMarks({});
                  }}
                  startIcon={<CloseIcon />}
                >
                  Cancel Editing
                </Button>
              </Box>
            )}
          </CardContent>
        </Card>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity="info" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Exam;